import { LiveAnnouncer } from '@angular/cdk/a11y';
import { JsonPipe, NgFor, NgIf } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import moment from 'moment';

import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';
import { QMSPaginatorComponent } from 'src/app/shared/components/qms-paginator/qms-paginator.component';
import { BreadcrumbItem } from 'src/app/shared/models/breadcrumb.interface';
import { DateFormatPipe } from 'src/app/shared/pipes/date-format.pipe';
import { environment } from 'src/environments/environment';
import { UserService } from '../../services/user.service';
import { FilterDateAccessedComponent } from './dialog/filter-date-accessed/filter-date-accessed.component';
import { SearchEmployeeFilter } from './models/search-emplyee-filter';
import {
  DefaultDate,
  EmployeeModel,
  FilterDateAccessed,
  FilterUser,
  NumberMonthAgo,
  SortParam,
} from './models/user-model';

@Component({
  selector: 'app-user',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    DateFormatPipe,
    QMSPaginatorComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatDatepickerModule,
    NgIf,
    NgFor,
    TranslateModule,
    AngularSvgIconModule,
    RouterModule,
    JsonPipe,
  ],
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
})
export class UserComponent {
  displayedColumns: string[] = [
    'firstName',
    'lastName',
    'departmentName',
    'username',
    'loginDomain',
    'lastAccessedDate',
    'action',
  ];

  dataSource!: MatTableDataSource<EmployeeModel>;
  totalCount = 0;

  breadcrumbItems: BreadcrumbItem[] = [];

  clear = 'clear';
  today = 'Today';
  lastMonth = 'LastMonth';
  last6Month = 'Last6Month';
  customDate = 'CustomDate';
  filterList = [
    { id: 1, text: 'USER.FILTER_USER.TODAY', stringQuery: this.today, isShowChecked: false },
    { id: 2, text: 'USER.FILTER_USER.LAST_MONTH', stringQuery: this.lastMonth, isShowChecked: false },
    { id: 3, text: 'USER.FILTER_USER.LAST_6_MONTHS', stringQuery: this.last6Month, isShowChecked: false },
    { id: 4, text: 'USER.FILTER_USER.CUSTOM_DATE', stringQuery: this.customDate, isShowChecked: false },
  ];
  isHiddenCustomDate: boolean = true;
  filter: SearchEmployeeFilter = new SearchEmployeeFilter();
  sortDirection: string = SortParam.FirstName_ASC;
  isOptionFilterPeriod!: boolean;

  @ViewChild(MatSort) sort!: MatSort;

  disableModeUpsertUser = environment.disableModeUpsertUser;
  filterForm: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    loginName: new FormControl(''),
  });
  submitted = false;

  constructor(
    private userService: UserService,
    public router: Router,
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.breadcrumbItems = [
      {
        name: 'SIDE_BAR.HOME',
        url: '/',
      },
      {
        name: 'SIDE_BAR.MANAGE_USER',
        url: '/admin/users',
      },
    ];
    this.filter.sortDirection = SortParam.FirstName_ASC;
    this.loadData();
  }

  ngAfterViewInit() {}
  pageEvent(event: PageEvent) {
    console.log(event);
    this.filter.pageIndex = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.loadData();
  }

  filterUser(data: string) {
    if (!!data) {
      if (!this.filterList.find((x) => x.id == FilterUser.ClearFilter)) {
        this.filterList = [];
        this.filterList.push({
          id: 0,
          text: 'USER.FILTER_USER.CLEAR',
          stringQuery: this.clear,
          isShowChecked: false,
        });
        this.filterList.push({
          id: 1,
          text: 'USER.FILTER_USER.TODAY',
          stringQuery: this.today,
          isShowChecked: false,
        });
        this.filterList.push({
          id: 2,
          text: 'USER.FILTER_USER.LAST_MONTH',
          stringQuery: this.lastMonth,
          isShowChecked: false,
        });
        this.filterList.push({
          id: 3,
          text: 'USER.FILTER_USER.LAST_6_MONTHS',
          stringQuery: this.last6Month,
          isShowChecked: false,
        });
        this.filterList.push({
          id: 4,
          text: 'USER.FILTER_USER.CUSTOM_DATE',
          stringQuery: this.customDate,
          isShowChecked: false,
        });
      }
      switch (data) {
        case this.clear:
          this.filterList = this.filterList.filter((x) => x.id !== FilterUser.ClearFilter);
          this.filter.toDate = null as unknown as Date;
          this.filter.fromDate = null as unknown as Date;
          this.isHiddenCustomDate = true;
          break;
        case this.today:
          this.filter.fromDate = new Date();
          this.filter.toDate = new Date();
          this.isHiddenCustomDate = true;
          break;
        case this.customDate:
          this.isHiddenCustomDate = false;
          break;
        case this.lastMonth:
          this.filter.fromDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - NumberMonthAgo.Last1Month,
            new Date().getDate(),
          );
          this.filter.toDate = new Date();
          this.isHiddenCustomDate = true;
          break;
        case this.last6Month:
          this.filter.fromDate = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - NumberMonthAgo.Last6Month,
            new Date().getDate(),
          );
          this.filter.toDate = new Date();
          this.isHiddenCustomDate = true;
          break;
        default:
          break;
      }
    }
    this.filter.sortDirection = this.sortDirection;
    if (this.isHiddenCustomDate) {
      this.filter.pageIndex = 1;
      this.loadData();
    }
  }

  loadData() {
    const minDate = moment.utc(DefaultDate.MinDate);
    this.userService.searchEmployeesByMultipleParam(this.filter).subscribe((res) => {
      this.dataSource = new MatTableDataSource<EmployeeModel>(res.employees);
      this.dataSource.sort = this.sort;
      this.totalCount = res.total;
    });
  }

  openDialogFilterCustomDate(): void {
    const dialogRef = this.dialog.open(FilterDateAccessedComponent, {
      autoFocus: false,
      disableClose: false,
      width: '370px',
    });
    dialogRef.componentInstance.specificDateInput = this.filter.toDate;
    dialogRef.componentInstance.toDateInput = this.filter.toDate;
    dialogRef.componentInstance.fromDateInput = this.filter.fromDate;
    dialogRef.componentInstance.isOptionFilterPeriodInput = this.isOptionFilterPeriod;
    dialogRef.afterClosed().subscribe((result: FilterDateAccessed) => {
      this.isOptionFilterPeriod = result.isOptionFilterPeriod;
      if (result.isOptionFilterPeriod) {
        this.filter.toDate = new Date(result.toDate);
        this.filter.fromDate = new Date(result.fromDate);
      } else {
        this.filter.toDate = this.filter.fromDate = result.specificDate;
      }
      if (result.isReload) {
        this.loadData();
      }
    });
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.filterForm.invalid) {
      return;
    }

    this.filter.lastName = this.filterForm.get('lastName')?.value;
    this.filter.firstName = this.filterForm.get('firstName')?.value;
    this.filter.loginName = this.filterForm.get('loginName')?.value;

    this.filter.pageIndex = 1;
    this.loadData();
  }
}
